export const TAB_ITEM_WIDTH = 183;
export const TABS_PADDING = 4;
